import { defineWidgets } from "../utils/defineWidgets.ts";

export const widgets = defineWidgets({
  "ld-tennis-calendar": () => import("./calendar/calendar.tsx"),
  "ld-tennis-ranking": () => import("./ranking/ranking.tsx"),
  "ld-tennis-results-categories": () => import("./results-categories/results-categores.tsx"),
  "ld-tennis-results-container": () => import("./results-container/results-container.tsx"),
  "ld-tennis-results": () => import("./results/results.tsx"),
  "ld-tennis-live-score": () => import("./live-score/live-score.tsx"),
  "ld-tennis-sdapi-calendar": () => import("./sdapi-calendar/calendar.tsx"),
  "ld-tennis-sdapi-live-score": () => import("./sdapi-live-score/live-score.tsx"),
  "ld-tennis-sdapi-ranking": () => import("./sdapi-ranking/ranking.tsx"),
  "ld-tennis-sdapi-results": () => import("./sdapi-results/results.tsx"),
  "ld-tennis-sdapi-results-categories": () => import("./sdapi-results-categories/results-categores.tsx"),
  "ld-tennis-sdapi-results-container": () => import("./sdapi-results-container/results-container.tsx"),
});
